import React, { useState, useEffect } from "react";
import Header from "@Components/Header/Header";
import Footer from "@Components/Footer/Footer";
import BreadcrumbPage from "@Components/Home/BreadcrumbPage/BreadcrumbPage";
import FormPage from "@Components/MultiForm/FormPage/FormPage"
import moment from "moment/dist/moment";
import ContactSection from "@Components/MultiForm/ContactSection/ContactSection";
import ScrollAnimation from "react-animate-on-scroll";
import * as qs from "query-string"
import { postFormData } from "@Components/forms/api/Api"
import axios from "axios"
import loadable from '@loadable/component'
import ReCaptchaBox from '@Components/forms/elements/recaptcha'
import $ from 'jquery/dist/jquery.min.js'
import AddressSearch from 'react-loqate'
import DatePicker, { registerLocale } from "react-datepicker"
import {
  VALUATION_PAGE_URL, CONTACT_PAGE_URL, BAC_PAGE_URL
} from "@Components/common/site/constants";
import { Link } from "@StarberryUtils";
import "react-datepicker/dist/react-datepicker.css"
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Breadcrumb } from "react-bootstrap";
import { getUser } from "@starberry/myaccount-website-utils"
const AddressSearchInput = (props) => {
  
  // console.log(props)
  // var SeLAdd = sessionStorage.getItem('SelectedAdress')
  // document.getElementById('address').value = SeLAdd

  return (
    <div className="custom-float">
      <input
        name="address"
        placeholder="Start typing your address"
        autocomplete="off"
        type="text"
        id="address"
        class="form-control"
        {...props}
        value={props.addressLabel}
        required="true"

      />

    </div>
  );
};
const Valuation = (props) => {
  const userData = getUser();
  const [startDate, setStartDate] = useState(
    // setHours(setMinutes(new Date(), 0), 0)
    new Date()
  )
  const recaptchaRef = React.createRef();
  const [formvalues, setFormvalues] = useState("");
  const [token, setToken] = useState("");
  const handleBack = () => window.history.back();
  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.setItem('date', new Date())
    // setStep(sessionStorage.getItem('step') != null ? parseInt(sessionStorage.getItem('step')) : 0)
    setName(sessionStorage.getItem('name') != null ? sessionStorage.getItem('name') : userData?.name)
    setEmail(sessionStorage.getItem('email') != null ? sessionStorage.getItem('email') : userData?.email)
    setPhone(sessionStorage.getItem('telephone') != null ? sessionStorage.getItem('telephone') : userData?.mobile)
    setAddress(sessionStorage.getItem('address') != null ? sessionStorage.getItem('address') : '')
    setPropertySell(sessionStorage.getItem('sellorlet') != null ? sessionStorage.getItem('sellorlet') : '')
    setTiming(sessionStorage.getItem('Timing') != null ? sessionStorage.getItem('Timing') : '')
    setStartDate(new Date())
    setAddress(sessionStorage.getItem('address') != null ? sessionStorage.getItem('address') : '')
    setDate(sessionStorage.getItem('date') != null ? sessionStorage.getItem('date') : new Date())
    // setAddressBuildingName(sessionStorage.getItem('addressBuildingName') != null ? sessionStorage.getItem('addressBuildingName') : '')
    // setAddressBuildingNumber(sessionStorage.getItem('addressBuildingNumber') != null ? sessionStorage.getItem('addressBuildingNumber') : '')
    // setAddressPostalCode(sessionStorage.getItem('addressPostalCode') != null ? sessionStorage.getItem('addressPostalCode') : '')
    // setAddressSubBuilding(sessionStorage.getItem('addressSubBuilding') != null ? sessionStorage.getItem('addressSubBuilding') : '')
    // setAddressStreet(sessionStorage.getItem('addressStreet') != null ? sessionStorage.getItem('addressStreet') : '')
    // var addressLabel = sessionStorage.getItem('addressLabel') != null ? sessionStorage.getItem('addressLabel') : ''
    // document.getElementById('address')?.value = addressLabel

  }, []);
  const [step, setStep] = useState(0)
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState(false)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [valemailError, setValEmailError] = useState(false)
  const [phone, setPhone] = useState('')
  const [phoneError, setPhoneError] = useState(false)
  const [valphoneError, setValPhoneError] = useState(false)
  const [address, setAddress] = useState('')
  const [addressError, setAddressError] = useState('')
  const [timing, setTiming] = useState(false)
  const [propertySell, setPropertySell] = useState(false)
  const [date, setDate] = useState(null)
  const [submitted, stepSubmitted] = useState(false)
  const [addressBuildingName, setAddressBuildingName] = useState('')
  const [addressBuildingNumber, setAddressBuildingNumber] = useState('')
  const [addressPostalCode, setAddressPostalCode] = useState('')
  const [addressSubBuilding, setAddressSubBuilding] = useState('')
  const [addressStreet, setAddressStreet] = useState('')
  const [valpalsell, setValpalSell] = useState('')
  const [valpallet, setValpalLet] = useState('')
  const setPropertySellF = (event) => {
    setPropertySell(event)
    sessionStorage.setItem('sellorlet', event)
  }
  const setTimingF = (event) => {
    setTiming(event)
    sessionStorage.setItem('Timing', event)
  }
  const handleAddress = (address) => {
    document.getElementById('address').value = address.Label.replace(/\n/g, ", ")
    document.getElementById('addressBuildingName').value = address.BuildingName
    document.getElementById('addressBuildingNumber').value = address.BuildingNumber
    document.getElementById('addressPostalCode').value = address.PostalCode
    document.getElementById('addressSubBuilding').value = address.SubBuilding
    document.getElementById('addressStreet').value = address.Street
    sessionStorage.setItem('addressBuildingName', address.BuildingName)
    sessionStorage.setItem('addressBuildingNumber', address.BuildingNumber)
    sessionStorage.setItem('addressPostalCode', address.PostalCode)
    sessionStorage.setItem('addressSubBuilding', address.SubBuilding)
    sessionStorage.setItem('addressStreet', address.Street)
    sessionStorage.setItem("addressLabel", address.Label.replace(/\n/g, ", "))

    if (!address) {
      $('.address-group').addClass('field-invalid');
      $('.error').html("<p>Please enter property address</p>");
    }
    else {
      $('.address-group').removeClass('field-invalid');
      $('.error').html('');
      $('.address.form-control').removeClass('error-border');
    }

  }
  const onSelectDate = (date) => {
    sessionStorage.setItem('date', date)
  }
  const onChange = (e) => {
    sessionStorage.setItem(e.target.name, e.target.value)
    if (e.target.name === 'name') {
      setName(e.target.value)
      if (e.target.value !== "") {
        setNameError(false)
      }
      else {
        setNameError(true)
      }
    }
    if (e.target.name === 'email') {
      setEmail(e.target.value)
      if (e.target.value === "") {
        setEmailError(true)
      }
      else if (e.target.value.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null) {
        setValEmailError(true)
        setEmailError(false)
      }
      else {
        setEmailError(false)
        setValEmailError(false)
      }
    }
    if (e.target.name === 'telephone') {
      setPhone(e.target.value)
      if (e.target.value === "") {
        setPhoneError(true)
      }
      else if (e.target.value.match("^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$") === null) {
        setValPhoneError(true)
        setPhoneError(false)
      }
      else {
        setPhoneError(false)
        setValPhoneError(false)
      }
    }
    if (e.target.name === 'address') {
      setAddress(e.target.value)
      if (e.target.value === "") {
        setAddressError(true)
      }
      else {
        setAddressError(false)
      }

    }


  }

  const next = event => {
    if (step === 0) {
      if (!name) {
        if (!name) {
          setNameError(true)
        }
      }
      else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step + 1)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'valuation-step-one',
          'formId': 'valuation-step-one',
          'formName': 'Valuation Step One',
          'formLabel': 'Valuation Step One'
        });
      }
    }
    if (step === 1) {
      if (!email || !phone || email.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null || phone.match("^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$") === null) {
        if (!email) {
          setEmailError(true)
        }
        if (email.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null) {
          setValEmailError(true)
        }
        if (!phone) {
          setPhoneError(true)
        }
        if (phone.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null) {
          setValPhoneError(true)
        }
      }
      else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step + 1)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'valuation-step-two',
          'formId': 'valuation-step-two',
          'formName': 'Valuation Step Two',
          'formLabel': 'Valuation Step Two'
        });
      }
    }
    else if (step === 2) {
      if (!propertySell) {
        stepSubmitted(true)
      }
      else if (!address) {
        setAddressError(true)
      }

      else {

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step + 1)
        stepSubmitted(false)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'valuation-step-three',
          'formId': 'valuation-step-three',
          'formName': 'Valuation Step Three',
          'formLabel': 'Valuation Step Three'
        });
      }
    }
    else if (step === 3) {
      if (!timing || !startDate) {
        stepSubmitted(true)
      }
      else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step + 1)
        var selectedaddress = $("input[name=address]").val();
        $("input[name=selected_address]").val(selectedaddress);
        setDate(sessionStorage.getItem('date'))
        const formsdata = (event.target);
        event.preventDefault();
        const json = {}
        Object.keys(formsdata).map(key => (
          json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
        ))
        json['email_temp_user'] = "valuation_user";
        json['email_temp_admin'] = "valuation_admin";
        json['formname'] = "Valuation";
        if (json['subject']) {
          json['formname'] = 'Valuation';
        }
        // json['type_of_valuation'] = sessionStorage.getItem('type_of_valuation');
        json['name'] = sessionStorage.getItem('name');
        json['email'] = sessionStorage.getItem('email');
        json['telephone'] = sessionStorage.getItem('telephone');
        json['address'] = sessionStorage.getItem('address');
        json['sellorlet'] = sessionStorage.getItem('sellorlet');
        json['date_time'] = moment(sessionStorage.getItem('date')).format("DD-MM-YYYY") + ', ' + sessionStorage.getItem('Timing');
        json['g-recaptcha-response'] = token;
        json['to_email_id'] = sessionStorage.getItem('sellorlet') === "sell" ? process.env.VALUATION_SALES_MAIL_TO : sessionStorage.getItem('sellorlet') === "let" ? process.env.VALUATION_RENT_MAIL_TO : null
        setFormvalues(json);
        recaptchaRef.current.execute();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step + 1)
        setgobackPage(true)
        window.scrollTo(0, 0);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'valuation-step-three',
          'formId': 'valuation-step-three',
          'formName': 'Valuation Step Three',
          'formLabel': 'Valuation Step Three'
        });
      }

    }

  }

  const previous = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })

    setStep(step - 1)
    // sessionStorage.setItem('step', step - 1)

  }

  useEffect(() => {
    // Initialize Bootstarp file upload field value retain js
    // bsCustomFileInput.init()

    if (token !== '') {


      const processFromData = async () => {

        let formData = new FormData();

        formData.append('data', JSON.stringify(formvalues));

        postFormData(formData).then(apiRes => {

          const axiosOptions_email = {
            url: '/.netlify/functions/server/valuation',
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: qs.stringify(formvalues),
          }

          axios(axiosOptions_email)
            .then(response => {
              console.log('mail sent!')
              // next()
              sessionStorage.removeItem("name")
              sessionStorage.removeItem("email")
              sessionStorage.removeItem("telephone")
              sessionStorage.removeItem("date")
              sessionStorage.removeItem("address")
              // sessionStorage.removeItem("type_of_valuation")
              sessionStorage.removeItem('sellorlet');
            })
            .catch(err => {

            }
              // console.log(err)
            );
        });

        // tracking event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'form-' + sessionStorage.getItem('sellorlet'),
          'formId': 'form-' + sessionStorage.getItem('sellorlet'),
          'formName': 'Valuation',
          'formLabel': 'Valuation'
        });

        // next()

      }
      processFromData();
    }
  }, [token]);
  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };
  const [gobackPage, setgobackPage ] = useState(false)

  return (
    <React.Fragment>
      <div className="header-logo-black form-page-menubar"><Header gobackPage={gobackPage} step={step} previous={previous} /></div>

      {step === 0 ? <>
        <section className="multi-form-section">
          <Container>

            <Row className="d-lg-none">
              <Col lg={12}>
                <Link to={'/'} className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Link>
              </Col>
            </Row>
            <div className="form-container">
              <Row>
                <Col lg={12}>
                  <ScrollAnimation animateOnce={true} animateIn="fadeInUp"><h1>Thank you for reaching out. Let’s start with your name please.</h1></ScrollAnimation>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="form">
                    <Form.Group controlId="formBasicName">
                        <div className="custom-float">
                          <Form.Control className={nameError ? 'error-border' : ''} autoComplete="off" value={name} onChange={onChange} name="name" type="text" placeholder="Enter your name" required="true" />
                          <label className="plclabel">Your Name</label>
                          {nameError &&
                            <div className="error">
                              Please Enter name.
                            </div>
                          }
                        </div>
                    </Form.Group>

                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                      <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                    </ScrollAnimation>

                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </>
        : step === 1 ? <>
          <section className="multi-form-section">
            <Container>

              <Row className="d-lg-none">
                <Col lg={12}>
                  <Button onClick={() => previous()} type="button" className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Button>
                </Col>
              </Row>
              <div className="form-container">
                <Row>
                  <Col lg={12}>
                    <ScrollAnimation animateOnce={true} animateIn="fadeInUp"><h1>Thanks {name}. Now we’ll need your contact details.</h1></ScrollAnimation>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="form">
                      <Form.Group controlId="formBasicEmail">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <div className="custom-float">
                            <Form.Control className={emailError ? 'error-border' : valemailError ? 'error-border' : ''} autoComplete="off" value={email} onChange={onChange} name="email" type="email" placeholder="" required="true" />
                            <label className="plclabel">Your E-mail</label>
                            {emailError &&
                              <div className="error">
                                Please Enter Email.
                              </div>
                            }
                            {valemailError && !emailError &&
                              <div className="error">
                                Please Enter Valid Email.
                              </div>
                            }
                          </div>
                        </ScrollAnimation>
                      </Form.Group>

                      <Form.Group controlId="formBasicTelephone">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <div className="custom-float">
                            <Form.Control maxLength={13} className={phoneError ? 'error-border' : valphoneError ? 'error-border' : ''} autoComplete="off" value={phone} onChange={onChange} name="telephone" type="text" placeholder="Enter your Telephone" required="true" />
                            <label className="plclabel">Your Telephone</label>
                            {phoneError &&
                              <div className="error">
                                Please Enter Telephone.
                              </div>
                            }
                            {valphoneError && !phoneError &&
                              <div className="error">
                                Please Enter Valid Telephone.
                              </div>
                            }
                          </div>
                        </ScrollAnimation>
                      </Form.Group>

                      <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                      </ScrollAnimation>

                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </> : step === 2 ? <>
          <section className="multi-form-section">
            <Container>

              <Row className="d-lg-none">
                <Col lg={12}>
                  <Button onClick={() => previous()} type="button" className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Button>
                </Col>
              </Row>
              <div className="form-container">
                <Row>
                  <Col lg={12}>
                    <ScrollAnimation animateOnce={true} animateIn="fadeInUp"><h1>Now we need your property information.</h1></ScrollAnimation>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="form">
                      <Form.Group className="address" controlId="address">
                        {/* <input id="addressBuildingName" type="hidden" name="addressBuildingName" /> */}
                        {/* <input id="addressBuildingNumber"  type="hidden" name="addressBuildingNumber" />
          <input id="addressPostalCode"  type="hidden" name="addressPostalCode" />
          <input id="addressSubBuilding"  type="hidden" name="addressSubBuilding" />
          <input id="addressStreet"  type="hidden" name="addressStreet" /> */}


                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <div className="custom-float">
                            {/* <AddressSearch
                        locale="en_GB"
                        apiKey={process.env.GATSBY_LOQATE_API_KEY}
                        countries={['GB']}
                        components={{ Input: AddressSearchInput }}
                        className="address-search-box"
                        inputClassname="address form-control"
                        listClassname="address-options"
                        listItemClassname="address-option"
                        onSelect={(address) => handleAddress(address)}
                        onChange={onChange}
                        
                        /> */}
                            <Form.Control className={addressError ? 'error-border' : ''} autoComplete="off" value={address} onChange={onChange} name="address" type="text" placeholder="Please Enter Your Address..."  required="true"/>
                            <label className="plclabel">Your Address</label>
                            {addressError &&
                              <div className="error">
                                Please Enter Address
                              </div>
                            }
                          </div>
                        </ScrollAnimation>
                        <div className="error">

                        </div>
                      </Form.Group>

                      <Form.Group controlId="formBasicType">
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp"><Form.Label>Do you want to Sell or Let your property</Form.Label></ScrollAnimation>
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <div className="form-button-groups">
                            <Button onClick={() => setPropertySellF('sell')} type="button" variant="outline" className={propertySell === 'sell' ? "active outline-orange" : "outline-orange"}>I’d like to Sell</Button>
                            <Button onClick={() => setPropertySellF('let')} type="button" variant="outline" className={propertySell === 'let' ? "active outline-orange" : "outline-orange"}>I’d like to Let</Button>
                            {!propertySell && submitted &&
                              <div className="error">
                                Please choose an option.
                              </div>
                            }
                          </div>
                        </ScrollAnimation>
                      </Form.Group>

                      <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                      </ScrollAnimation>

                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </> : step === 3 ? <>
          <section className="multi-form-section">
            <Container>

              <Row className="d-lg-none">
                <Col lg={12}>
                  <Button onClick={() => previous()} type="button" className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Button>
                </Col>
              </Row>
              <div className="form-container">
                <Row>
                  <Col lg={12}>
                    <ScrollAnimation animateOnce={true} animateIn="fadeInUp"><h1>Lastly, we need your preferred date and time.</h1></ScrollAnimation>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="form">
                      <Form.Group controlId="formBasicPreferredDate">
                        {/* <ScrollAnimation animateOnce={true} animateIn="fadeIn"> */}
                        <Form.Label>Preferred Date</Form.Label>
                        <DatePicker
                          className="form-control"
                          selected={startDate}
                          minDate={new Date()}
                          onChange={date => {
                            setStartDate(date)
                            onSelectDate(date)
                          }}
                          dateFormat="dd, MMMM yyyy"
                          locale="en-gb"
                        />
                        {/* </ScrollAnimation> */}
                      </Form.Group>
                      <Form.Group controlId="formBasicTelephone">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <Form.Label>Preferred Time</Form.Label>
                          <div className="form-button-groups grid-3">
                            <Button onClick={() => setTimingF('Morning')} variant="outline" className={timing === "Morning" ? "active outline-primary" : "outline-primary"}>Morning<br /><span>9 AM to 12 PM</span></Button>
                            <Button onClick={() => setTimingF('Afternoon')} variant="outline" className={timing === "Afternoon" ? "active outline-primary" : "outline-primary"}>Afternoon<br /><span>12 PM to 4 PM</span></Button>
                            <Button onClick={() => setTimingF('Evening')} variant="outline" className={timing === "Evening" ? "active outline-primary" : "outline-primary"}>Evening<br /><span>4 PM to 7 PM</span></Button>
                            {!timing && submitted &&
                              <div className="error">
                                Please choose an option.
                              </div>
                            }
                          </div>
                        </ScrollAnimation>
                      </Form.Group>
                      <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                      </ScrollAnimation>

                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>

        </> :






          <ContactSection />}
      <ReCaptchaBox
        className="py-2"
        captRef={recaptchaRef}
        key="captcha"
        handleonVerify={handleonVerify}
      />
    </React.Fragment>

  )
}



export default Valuation